import apiRequest from 'utils/api/apiRequest';
import * as URLS from './urls';

export const dashboardApi = {
  loadStatistics: (monitorId) => {
    return apiRequest(`${URLS.STATISTICS}/${monitorId}`);
  },
  loadDDEvents: (data) => {
    return apiRequest(`${URLS.DD_EVENTS}/`, { method: 'post', data });
  },
  loadCIPEvents: (data) => {
    return apiRequest(`${URLS.CIP_EVENTS}/`, { method: 'post', data });
  },
  loadCIPStrengthEvents: (data) => {
    return apiRequest(`${URLS.CIP_STRENGTH_EVENTS}/`, { method: 'post', data });
  },
  loadOverviewByMonitoringId: (id) => {
    return apiRequest(`${URLS.MONITOR}/overview/${id}`);
  },
};
